import IMAGES from "../../../../assets/images/images";
import { Loader } from "../../../../components/loader/Loader";
import { formatDate } from "../../../../utils/arrayUtils";
import styles from "./activitylog.module.css";

export default function ActivityLog(props) {
    const avtivitydata = props?.activitylogs?.activitylog?.data;

    function getLogDetails(actionType, userName = "") {
        const map = {
            "demand-created": {
                logLabel: "Demand Created",
                logMessage: `Demand request created by ${userName}.`,
            },

            "initiate-feasibiity": {
                logLabel: "Feasibility Initiated",
                logMessage: `Feasibility assessment initiated by ${userName}.`,
            },

            "complete-feasibiity": {
                logLabel: "Feasibility Completed",
                logMessage: `Feasibility assessment completed by ${userName}.`,
            },

            "initiate-floor-pricing": {
                logLabel: "Floor Pricing Initiated",
                logMessage: `Floor pricing initiated by ${userName}.`,
            },

            "initiate-margin": {
                logLabel: "Floor Price Generated",
                logMessage: `Floor price generated and shared with the Account Manager for quotation preparation by ${userName}.`,
            },

            "generate-quotation": {
                logLabel: "Quotation submitted",
                logMessage: ` Quotation submitted and shared with customer by ${userName}.`,
            },

            "approve-quotation": {
                logLabel: "Quotation Approved",
                logMessage: `Quotation approved by ${userName}.`,
            },

            "reject-quotation": {
                logLabel: "Quotation Rejected",
                logMessage: `Quotation rejected by ${userName}.`,
            },

            "complete-draft-orderform": {
                logLabel: "Order Form Completed",
                logMessage: `Order form completed by ${userName}.`,
            },

            "save-orderform": {
                logLabel: "Order Form Saved",
                logMessage: `Order form saved and downloaded by ${userName}.`,
            },

            "submit-signed-orderform": {
                logLabel: "Signed Order Form Submitted",
                logMessage: `Signed order form submitted by ${userName}.`,
            },

            "intiate-legal-contract": {
                logLabel: "Legal Contract Initiated",
                logMessage: `Legal contract initiated by ${userName}.`,
            },

            "upload-legal-contract": {
                logLabel: "Legal Contract Uploaded",
                logMessage: `Legal contract uploaded by ${userName}.`,
            },

            "initiate-provisioning": {
                logLabel: "Provisioning Initiated",
                logMessage: `Service provisioning initiated by ${userName}.`,
            },

            "complete-provisioning": {
                logLabel: "Provisioning Completed",
                logMessage: `Service provisioning completed by ${userName}.`,
            },

            "complete-billing": {
                logLabel: "Billing Completed",
                logMessage: `Billing process completed by ${userName}.`,
            },

            "complete-demand": {
                logLabel: "Demand Completed",
                logMessage: "Demand marked as completed.",
            },

            "close-demand": {
                logLabel: "Demand Cancelled",
                logMessage: `Demand cancelled by ${userName}.`,
            },

            "comment-added": {
                logLabel: "New Comment Added",
                logMessage: `Comment added by ${userName}.`,
            },
            "expire-quotation": {
                logLabel: "Quotation Expired",
                logMessage: `Quotation Expired By ${userName}.`,
            },
            "close-demand-by-system": {
                logLabel: "Demand Closed",
                logMessage: `Demand closed by system.`,
            },
        };

        return (
            map[actionType] || {
                logLabel: "",
                logMessage: "",
            }
        );
    }

    if (props?.activitylogs?.loading) return <Loader />;

    return (
        <div>
            {avtivitydata?.length === 0 ? (
                <div className={styles.empty}>No activity logs available</div>
            ) : (
                <div>
                    {avtivitydata?.map((data, index) => {
                        const { logLabel, logMessage } = getLogDetails(
                            data?.actionType,
                            data?.createdBy?.name
                        );
                        return (
                            <div
                                key={index}
                                className={styles.containerWrapper}
                            >
                                <div className={styles.container}>
                                    <div className={styles.datewrapper}>
                                        <div className={styles.datastate}>{logLabel}</div>
                                        <div className={styles.datadate}>
                                            {formatDate(data?.createdAt)}
                                        </div>
                                    </div>

                                    <div className={styles.data}>{logMessage}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}